export const isLinkRegex =
  /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
export const isObjectId = value => value.match(/^[0-9a-fA-F]{24}$/);
